// Libs
import React, { Component } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router';
import moment from 'moment';
 
// Services
import API from 'API';

// Components
import Layout from 'components/layout/Layout';
import Loader from 'components/common/Loader';
import BookAppt from 'components/BookAppt';

// Components - pages
// TODO

window.moment = moment;

//-------------------------------------------------------------------------------------------------------------------

class App extends Component {

    static VERSION = 'ob1.25';

    constructor(props) {
        super(props);

        this.setAccountInfo = this.setAccountInfo.bind(this);

        this.state = {
            isLoading: true,
            accountInfo: null
        };
    }

    setAccountInfo(accountInfo, callback) {
        this.setState({ accountInfo }, callback);
    }

    //-------------------------------------------------------------------------------------------------------------------

    render() {
        const { accountInfo } = this.state;

        const getChildProps = (props) => ({
            ...props.match.params,
            stepName: props.match.params.stepName || 'findProperty',
            stepParam: props.match.params.stepParam,
            history: props.history,
            fns: {
                setAccountInfo: this.setAccountInfo
            }
        });

        return (
            <Layout accountInfo={accountInfo}>
                <Switch>
                    <Route path="/:stepName?/:stepParam?" render={(props) =>
                        <BookAppt {...getChildProps(props)} />}
                    />
                    <Redirect to="/" />
                </Switch>

            </Layout>
        );
    }
}

export default withRouter(App);
